import SiteHeader from "./site-header";
import SearchBar from "./atoms/search-bar";
import SiteFooter from "./site-footer";
import loadYoutube from "./atoms/yt-video";
import { isVisible } from "./helpers";
import Choices from 'choices.js';
import AddParticipants from "./modules/add-participants";
window.Choices = Choices;

const selects = document.querySelectorAll( '.styled-select' );

function handleSelectChange(event) {
	const selectedValue = event.target.value;
	updateTargetElements( selectedValue );
}

function updateTargetElements(selectedValue) {
	const targetElements = document.querySelectorAll( '.prod_details__date' );
	const targetElementsMode = document.querySelectorAll( '.prod_details__mode' );
  const lowstockElements = document.querySelectorAll(".add-to-cart__quantity .low-stock");

	targetElements.forEach(
		function(element) {
			const city = element.getAttribute( 'data-city' );
			const date = element.getAttribute( 'data-date' );
      const eventId = element.getAttribute( 'data-eventId' );
      const vacancies = Number(element.getAttribute( 'data-vacancies' ));
			const optionCity = selectedValue.split( '|' )[0].split( '=' )[1];
			const optionDate = selectedValue.split( '|' )[4].split( '=' )[1];
      const optionEventId = selectedValue.split( '|' )[7].split( '=' )[1];
      const promotion = selectedValue.split( '|' )[8].split( '=' )[1];

      const labelSale = element.closest('.add-to-cart')?.querySelector('.label--sale');

      if ( eventId === optionEventId ) {
				element.classList.add( 'active' );
        if (vacancies <= 4) {
          lowstockElements.forEach(
            function(lowstock) { 
                lowstock.classList.remove( 'hidden' );
            }
          );
        } else {
          lowstockElements.forEach(
              function(lowstock) { 
                lowstock.classList.add( 'hidden' );
              }
            );
        }
			} else {
				element.classList.remove( 'active' );
			}

      if ( labelSale ) {
        if ( promotion === '1') {
          labelSale.classList.remove( 'hidden' );
        } else {
          labelSale.classList.add( 'hidden' );
        }
      }
		}
	);

	targetElementsMode.forEach(
		function(element) {
			const eventId = element.getAttribute( 'data-eventId' );
			const optionEventId = selectedValue.split( '|' )[7].split( '=' )[1];
			if ( eventId === optionEventId ) {
				element.classList.add( 'active' );
			} else {
				element.classList.remove( 'active' );
			}
		}
	);
}

document.addEventListener(
	'DOMContentLoaded',
	function() {
		if (selects) {
			Array.from( selects ).forEach(
				(item, number) => {
					new Choices(
						item,
						{
							searchEnabled: false,
							placeholder: true,
							itemSelectText: '',
              shouldSort: false,
						}
					);
				if (item.classList.contains( 'product-date-select' )) {
					item.addEventListener( 'change', handleSelectChange );
					updateTargetElements( item.value );
				}
				}
			);
		}
	}
);

(() => {
	new SiteHeader();
	new SearchBar();
	new SiteFooter();
})()

if (
	( 'complete' === document.readyState ||
		'loading' !== document.readyState ) &&
	! document.documentElement.doScroll
) {
	AddParticipants();
} else {
	document.addEventListener( 'DOMContentLoaded', AddParticipants );
}



// Mini cart
function showMiniCart() {
	let miniCart = document.getElementById( "mini-cart" );
	if (miniCart) {
		if (miniCart.classList.contains( "is-open" )) {
			closeMiniCart();
		} else {
			miniCart.classList.add( "is-open" );
			document.body.classList.add( "is-mini-cart-open" );
			window.addEventListener( 'click', closeCartByOutsideClick );
		}
	}
}

function closeMiniCart() {
	document.getElementById( "mini-cart" ).classList.remove( "is-open" );
	window.removeEventListener( 'click', closeCartByOutsideClick );
	document.body.classList.remove( "is-mini-cart-open" );
}

function closeCartByOutsideClick(event) {
	if ( ! document.getElementById( "mini-cart" ).contains( event.target ) && ! Array.from( document.querySelectorAll( ".mini-cart-open" ) ).reduce( (accumulator, currentValue) => accumulator ? true : currentValue.contains( event.target ), false )) {
		closeMiniCart();
	}
}

Array.from( document.querySelectorAll( ".mini-cart-open" ) ).forEach( trigger => trigger.addEventListener( 'click', showMiniCart ) );
Array.from( document.querySelectorAll( ".mini-cart-close" ) ).forEach( trigger => trigger.addEventListener( "click", closeMiniCart ) );


jQuery( 'body' ).on(
	'added_to_cart',
	function (e, fragments, cart_hash, this_button) {
		showMiniCart()
	}
);

// Shop sidebar widgets
let shopWidgets            = document.querySelectorAll( '.shop-sidebar-widget' );
Array.from( shopWidgets ).forEach(
	(widget) => {
    let buttonShowMore = widget.querySelector( '.button-more' )
		if (buttonShowMore) {
			buttonShowMore.onclick = ( event ) => {
				if ( event.currentTarget.classList.contains( 'show-more' ) ) {
					  event.currentTarget.classList.remove( 'show-more' );
					  event.currentTarget.classList.add( 'show-less' );
					Array.from( widget.querySelectorAll( 'a.is-hidden' ) ).forEach(
						(item) => {
                        item.style.display = "block";
						}
					);
				} else {
					event.currentTarget.classList.remove( 'show-less' );
					event.currentTarget.classList.add( 'show-more' );
					Array.from( widget.querySelectorAll( 'a.is-hidden' ) ).forEach(
						(item) => {
                        item.style.display = "";
						}
					);
				}
			}
		}
	}
);

// Show order details
let expandButton = document.querySelectorAll( 'body.woocommerce-orders .woocommerce-MyAccount-content .summary__expand' )
if ( expandButton ) {  
	Array.from( expandButton ).forEach(
		(button) => {
        button.onclick = ( event ) => {
				  event.currentTarget.parentElement.parentElement.parentElement.classList.toggle( 'is-expanded' );
        }
		}
	);
}

// Single product
const handleScroll = () => {
	if ( ! document.querySelector( ".single-product" )) {
		return;
	}

	const hasScrolledPastElement = (element, offset) => {
		const rect               = element.getBoundingClientRect();
		return rect.bottom - offset <= 0;
	};

	const isElementVisible = (element, offset) => {
		const rect         = element.getBoundingClientRect();
		const windowHeight = window.innerHeight || document.documentElement.clientHeight;
		return rect.top - offset >= 0 && rect.bottom <= (windowHeight || document.documentElement.clientHeight);
	};

	if (window.innerWidth >= 768) {
		return;
	}

	const addToCartElement     = document.querySelector( ".add-to-cart" );
	const addToCartMiniElement = document.querySelector( ".add-to-cart-bar" );
	const headerElement        = document.querySelector( ".site-header" );
	const headerHeight         = headerElement.offsetHeight;

	if ( ! isElementVisible( addToCartElement, headerHeight ) && hasScrolledPastElement( addToCartElement, headerHeight )) {
		addToCartMiniElement.classList.add( "active" );
	} else {
		addToCartMiniElement.classList.remove( "active" );
	}
};

document.addEventListener( "scroll", handleScroll );
window.addEventListener( "resize", handleScroll );

let mobileCotactForm  = document.getElementById( "mobile-contact-form" );
let desktopCotactForm = document.getElementById( "desktop-contact-form" );
if ( mobileCotactForm && desktopCotactForm ) {
	if ( window.innerWidth > 768 ) {
		cloneForm( mobileCotactForm, desktopCotactForm );
	}

}

window.onresize = () => {
	if ( mobileCotactForm && desktopCotactForm ) {
		if (window.innerWidth > 768) {
			cloneForm( mobileCotactForm, desktopCotactForm );
		} else {
			cloneForm( desktopCotactForm, mobileCotactForm );
		}
	}
};

function cloneForm( fromWrapper, toWrapper ) {
	Array.from( fromWrapper.childNodes ).forEach(
		(element) => {
        toWrapper.appendChild( element.cloneNode( true ) );
        element.remove();
		}
	);
}

// Order by modal
let orderBy = document.querySelectorAll( "#orderby-form, .js-mobile-sort" );
if (orderBy.length > 0) {
	let prevScrollPos    = window.pageYOffset;
	const mainBar = document.querySelector('.main-search .ais-SearchBox-form');
	const fixedSearchBar = document.querySelector( '.fixed-search-bar' );
  if (fixedSearchBar) {
    window.addEventListener(
      'scroll',
      function() {
        const currentScrollPos = window.pageYOffset;
        let isVisibleMainBar = isVisible(mainBar);

        if (!isVisibleMainBar && currentScrollPos < prevScrollPos) {
          fixedSearchBar.classList.add( 'active' );
        } else {
          fixedSearchBar.classList.remove( 'active' );
        }

        if (currentScrollPos === 0) {
          fixedSearchBar.classList.remove( 'active' );
        }

        prevScrollPos = currentScrollPos;
      }
    );
  }

	let orderByForm  = document.querySelector( "#orderby-form" );
	let mobileSort   = document.querySelectorAll( ".js-mobile-sort" );
	let orderByModal = document.querySelector( '.woocommerce-ordering__modal' );
	let isModalOpen  = false;

	if (orderByForm) {
		orderByForm.addEventListener(
			'submit',
			function(event) {
				const anchorInput = orderByForm.querySelector( 'input[name="anchor"]' );
				if (anchorInput) {
					anchorInput.value = '#products-list';
				}
			}
		);
	}

	window.addEventListener(
		'DOMContentLoaded',
		function() {
			scrollToAnchor();
		}
	);

	function scrollToAnchor() {
		const urlParams   = new URLSearchParams( window.location.search );
		const anchorValue = urlParams.get( 'anchor' );
		if (anchorValue) {
			const decodedAnchor = decodeURIComponent( anchorValue );
			const anchorElement = document.querySelector( decodedAnchor );
			const siteHeader    = document.querySelector( '.site-header' );
			const offset        = siteHeader ? siteHeader.offsetHeight : 0;

			if (anchorElement) {
				const elementOffsetTop = getOffsetTop( anchorElement );
				window.scrollTo(
					{
						top: elementOffsetTop - offset,
						behavior: 'smooth'
					}
				);
			}
		}
	}

	function getOffsetTop(element) {
		let offsetTop = 0;
		while (element) {
			offsetTop += element.offsetTop;
			element    = element.offsetParent;
		}
		return offsetTop;
	}

	function openOrderByModal() {
		if ( ! isModalOpen) {
			orderByModal.classList.add( 'is-open' );
			isModalOpen = true;
			setTimeout(
				() => {
                window.addEventListener( 'click', closeOrderByModal );
				},
				0
			);
		}
	}

	function closeOrderByModal(event) {
		const modalBody   = document.querySelector( '.woocommerce-ordering__modal__body' );
		const radioInputs = modalBody.querySelectorAll( 'input[type="radio"]' );
		if ( ! modalBody.contains( event.target ) || isRadioInputClicked( event.target, radioInputs )) {
			orderByModal.classList.remove( 'is-open' );
			isModalOpen = false;
			window.removeEventListener( 'click', closeOrderByModal );
		}
	}

	function isRadioInputClicked(target, radioInputs) {
		return Array.from( radioInputs ).some(
			(input) => {
            return input.contains( target ) && input.checked;
			}
		);
	}

	function updateTestElement() {
		const checkedInput = document.querySelector( '#orderby-form input[type="radio"]:checked' );
		if (checkedInput) {
			testElement.textContent = checkedInput.nextElementSibling.textContent;
		}
	}

	const radioInputs = document.querySelectorAll( '#orderby-form input[type="radio"]' );
	const testElement = document.querySelector( '.woocommerce-ordering__checked' );

	radioInputs.forEach(
		input => {
        input.addEventListener( 'change', updateTestElement );
		}
	);

	updateTestElement();

	if (orderByForm) {
		orderByForm.addEventListener( 'click', openOrderByModal );
	}

	mobileSort.forEach(
		element => {
        element.addEventListener( 'click', openOrderByModal );
		}
	);
}


// Scroll to top
jQuery( ".scroll-top" ).click(
	function() {
		jQuery( "html, body" ).animate( { scrollTop: 0 }, "fast" );
		return false;
	}
);

// Inputs effects
let inputs = document.querySelectorAll( "input" );
if ( inputs ) {
	Array.from( inputs ).forEach(
		(input) => {
        if ( input.hasAttribute( 'id' ) ) {
            let label     = document.querySelector( 'label[for="' + input.id + '"]' );
            input.onfocus = ( event ) => {
                label.classList.add( 'is-active' );
            }
            input.onblur  = ( event ) => {
                label.classList.remove( 'is-active' );
            }
        }
		}
	);
}

// Checkout contact aside
let contactAside = document.getElementById( "contact-aside" );
if ( contactAside ) {
	contactAside.querySelector( '.contact-aside__trigger' ).onclick = ( event ) => {
		if ( contactAside.classList.contains( 'is-open' ) ) {
			contactAside.classList.remove( 'is-open' );
		} else {
			contactAside.classList.add( 'is-open' );
		}
		window.addEventListener(
			'click',
			function( e ) {
				if ( ! contactAside.contains( e.target ) && ! contactAside.contains( e.target ) ) {
					contactAside.classList.remove( 'is-open' );
				}
			}
		);
	};
	contactAside.querySelector( 'button.copy' ).onclick = ( event ) => {
		navigator.clipboard.writeText( contactAside.querySelector( 'span.number' ).innerText );
	}
}

// Product quantity spinners
function quantitySpinner() {

	let inputNumber = document.querySelectorAll( 'input[type="number"].qty' );

	if ( inputNumber ) {

		Array.from( inputNumber ).forEach(
			( input ) => {
            if ( ! input.parentNode.classList.contains( "quantity-spinner" ) ) {

                let inputSpinner = document.createElement( 'DIV' ),
                  minValue       = input.min,
                  maxValue       = input.max;
                inputSpinner.classList.add( "quantity-spinner" );

                // Input
                input.readOnly         = true;
                input.autocomplete     = 'off';
                inputSpinner.innerHTML = input.outerHTML;

                // Add
                let addBtn = document.createElement( "BUTTON" );
                addBtn.classList.add( "add" );
                addBtn.setAttribute( "type", "button" );
                addBtn.appendChild( document.createTextNode( "+" ) );
                addBtn.addEventListener(
                "click",
                () => {
                    let currentInput = remBtn.parentNode.querySelector( 'input[type="number"].qty' );
                    let value        = parseInt( currentInput.value, 10 );
                    value            = isNaN( value ) ? 0 : value;
                    value++;
                    currentInput.value = value;
                    if (maxValue && (parseInt( maxValue, 10 ) == value)) {
                        addBtn.disabled = true;
                    } else {
                        remBtn.disabled = false;
                    }
                    updateCart();
                }
                );
                if (maxValue && (parseInt( maxValue, 10 ) == input.value)) {
                      addBtn.disabled = true;
                }
                inputSpinner.appendChild( addBtn );

                // Remove
                let remBtn = document.createElement( "BUTTON" );
                remBtn.classList.add( "remove" );
                remBtn.setAttribute( "type", "button" );
                remBtn.appendChild( document.createTextNode( "-" ) );
                remBtn.addEventListener(
                "click",
                () => {
                    let currentInput = remBtn.parentNode.querySelector( 'input[type="number"].qty' );
                    let value        = parseInt( currentInput.value, 10 );
                    value            = isNaN( value ) ? 0 : value;
                    value--;
                    currentInput.value = value;
                    if (minValue && (parseInt( minValue, 10 ) == value)) {
                        remBtn.disabled = true;
                    } else {
                        addBtn.disabled = false;
                    }
                    updateCart();
                }
                );
                if (minValue && (parseInt( minValue, 10 ) == input.value)) {
                      remBtn.disabled = true;
                }
                inputSpinner.appendChild( remBtn );

                input.parentNode.replaceChild( inputSpinner, input );

            }
			}
		);
	}
}
// Call spinners
quantitySpinner();

// Auto update cart
function updateCart() {
	let cartForm = document.getElementsByClassName( 'woocommerce-cart-form' )[0];
	if (cartForm) {
		let cartUpdateBtn      = cartForm.querySelector( '[name=update_cart]' );
		cartUpdateBtn.disabled = false;
		cartUpdateBtn.click();
		jQuery( document.body ).on(
			'removed_from_cart updated_cart_totals updated_wc_div',
			function () {
				quantitySpinner();
			}
		);
	}
}

let prodExtras = document.querySelectorAll( '.prod_extras__button' );
if ( prodExtras ) {
	Array.from( prodExtras ).forEach(
		(trigger) => {
        trigger.onclick = (event) => {
				event.currentTarget.parentElement.classList.toggle( 'is-visible' )
			}
		}
	);
}

// Contact form label add class on validation
function styleClosestLabelOnSubmit(containerClass, inputClass, labelClass) {
	const containers = document.querySelectorAll( `.${containerClass}` );
	if (containers.length === 0) {
		return;
	}

	const handleClassChange = function(mutationsList) {
		mutationsList.forEach(
			mutation => {
            if (mutation.attributeName === "class") {
                const input = mutation.target;
                const label = input.closest( "div" ).querySelector( "label" );
                if (label) {
                    label.classList.toggle( labelClass, input.classList.contains( "wpcf7-not-valid" ) );
                }
            }
			}
		);
	};

	containers.forEach(
		container => {
        const inputs           = container.querySelectorAll( `.${inputClass}` );
        inputs.forEach(
			input => {
                const observer = new MutationObserver( handleClassChange );
                observer.observe( input, { attributes: true } );
			}
		);
		}
	);
}

styleClosestLabelOnSubmit( "wpcf7", "wpcf7-text", "error-label" );


// Contact form 7 disable submit before checked checkbox if required
const formPreValidation = () => {
	const contactForms  = document.querySelectorAll( '.wpcf7-form' );

	if (contactForms.length === 0) {
		return;
	}

	contactForms.forEach(
		(contactForm) => {
        const acceptances    = contactForm.querySelectorAll( 'span.wpcf7-acceptance:not(.optional)' );
        const formCheckboxes = contactForm.querySelectorAll( 'input[type="checkbox"][required]' );
        const submitButton   = contactForm.querySelector( 'button[type="submit"], input[type="submit"]' );
        submitButton.classList.add( 'not-accepted' );
        function validateForm() {
            let acceptancesChecked = true;
            let checkboxesChecked  = true;

            // Check acceptances
            if (acceptances.length > 0) {
                acceptancesChecked = Array.from( acceptances ).every(
                function (acceptance) {
                    return acceptance.classList.contains( 'checked' );
                }
                );
            }

            // Check formCheckboxes
            if (formCheckboxes.length > 0) {
                checkboxesChecked = Array.from( formCheckboxes ).every(
                function (checkbox) {
                    return checkbox.checked;
                }
                );
            }

            if (acceptancesChecked && checkboxesChecked) {
                submitButton.classList.remove( 'not-accepted' );
                submitButton.removeAttribute( 'disabled' );
            } else {
                submitButton.classList.add( 'not-accepted' );
                submitButton.setAttribute( 'disabled', 'disabled' );
            }
        }
        acceptances.forEach(
                function (acceptance) {
                    const checkbox = acceptance.querySelector( 'input[type="checkbox"]' );

                    checkbox.addEventListener(
                        'change',
                        function () {
                            if (this.checked) {
                                    acceptance.classList.add( 'checked' );
                            } else {
                                acceptance.classList.remove( 'checked' );
                            }
                            validateForm();
                        }
                    );
                }
		);
		formCheckboxes.forEach(
			function (checkbox) {
				checkbox.addEventListener(
					'change',
					function () {
						validateForm();
					}
				);
			}
		);
		validateForm();
		}
	);
}

formPreValidation();

// Cart confirmation checkboxes
document.addEventListener(
	'DOMContentLoaded',
	() => {
    if (document.body.classList.contains( 'woocommerce-cart' )) {
        const checkboxes    = document.querySelectorAll( '.preparation-confirmation' );
        const proceedButton = document.querySelector( '.wc-proceed-to-checkout .checkout-button' );

        const handleCheckboxChange = () => {
            let checkedCount       = 0;

            checkboxes.forEach(
            (checkbox) => {
                if (checkbox.checked) {
                    checkedCount++;
                }
            }
        );

        if (checkedCount < checkboxes.length) {
            proceedButton.classList.add( 'disabled' );
        } else {
            proceedButton.classList.remove( 'disabled' );
        }
        };

        checkboxes.forEach(
        (checkbox) => {
            checkbox.addEventListener( 'change', handleCheckboxChange );
            }
        );

        handleCheckboxChange();
    }
	}
);

// Knowledge base table of contents active check
const knowledgeSideMenuActive = () => {
	const sideMenu            = document.querySelector( '.knowledge-single__sidebar .knowledge-nav' );

	if ( ! sideMenu) {
		return;
	}

	const contentElements = document.querySelectorAll( ".knowledge-single__content > *" );
	const links           = document.querySelectorAll( ".knowledge-nav__link" );

	const removeActiveClassFromParents = () => {
		links.forEach(
			(link) => {
            link.parentNode.classList.remove( "active" );
			}
		);
	};

	const handleScroll = () => {
		removeActiveClassFromParents();

		for (let i = 0; i < contentElements.length; i++) {
			const contentElement = contentElements[i];
			const contentId      = contentElement.id;
			const link           = document.querySelector( `.knowledge - nav__link[href = "#${contentId}"]` );
			const rect           = contentElement.getBoundingClientRect();
			const isInView       = rect.top >= 0 && rect.bottom <= window.innerHeight;

			if (link && isInView) {
				const halfwayPoint    = rect.top + (rect.height / 2);
				const isHalfwayInView = halfwayPoint >= 0 && halfwayPoint <= window.innerHeight;

				if (isHalfwayInView) {
					link.parentNode.classList.add( "active" );
				} else if (i < contentElements.length - 1) {
					const nextContentElement = contentElements[i + 1];
					const nextContentId      = nextContentElement.id;
					const nextLink           = document.querySelector( `.knowledge - nav__link[href = "#${nextContentId}"]` );

					if (nextLink) {
						nextLink.parentNode.classList.add( "active" );
					}
				}
				break;
			}
		}
	};

	const scrollToAnchor = (event) => {
		event.preventDefault();

		const target       = event.target.getAttribute( "href" );
		const headerHeight = document.querySelector( '.site-header' ).offsetHeight;
		const offset       = document.querySelector( target ).offsetTop - headerHeight - 20;

		window.scrollTo(
			{
				top: offset,
				behavior: "smooth"
			}
		);
	};

	window.addEventListener( "scroll", handleScroll );

	links.forEach(
		(link) => {
        link.addEventListener( "click", scrollToAnchor );
		}
	);
};


document.addEventListener(
	'DOMContentLoaded',
	() => {
    var emailFields = document.querySelectorAll('input[type="email"]');

    emailFields.forEach(function(field) {
        field.addEventListener('change', function() {
            var email = field.value;

            field.setCustomValidity('');

            if (!validateEmailLetters(email)) {
                field.setCustomValidity(WLC.email_val_text.char);
                field.classList.add('error');
            } else if (!validateEmail(email)) {
                field.setCustomValidity(WLC.email_val_text.format);
                field.classList.add('error');
            } else {
                field.setCustomValidity('');
                field.classList.remove('error');
            }

            field.reportValidity();
        });

        field.addEventListener('keypress', function() {
          field.setCustomValidity('');
        })
    });

    function validateEmail(email) {
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
          return false;
      }

      if (email.startsWith('.')) {
          return false;
      }

      if (email.includes('.@') || email.includes('@.') || email.includes('..')) {
          return false;
      }

      if (email.endsWith('.')) {
        return false;
      }

      return true;
    }

    function validateEmailLetters(email) {
      var emailRegex = /^[a-zA-Z0-9@.]+$/;
      return emailRegex.test(email);
  }
  }
);


knowledgeSideMenuActive();
